import { useAuthedFileUrl } from '@/utils/authedFile';

/**
 * DP274-P3a-6 — an image a staff session is entitled to see.
 *
 * An <img src> cannot carry the session, so the bytes are fetched by the
 * app's own authed-file helper and shown from the blob. Used by the Site
 * Office (staff preview) and by the Project Desk party thread.
 */
export const AuthedImg = ({ src, alt, className }) => {
  const fetched = useAuthedFileUrl(src || null);
  if (!fetched.blobUrl) return null;
  return <img src={fetched.blobUrl} alt={alt} className={className} loading="lazy" />;
};

export default AuthedImg;
